/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Survey type enum
 * @export
 * @enum {string}
 */
export enum SurveyType {
    Renovation = 'RENOVATION',
    PartialDemolition = 'PARTIAL_DEMOLITION',
    Demolition = 'DEMOLITION'
}

export function SurveyTypeFromJSON(json: any): SurveyType {
    return SurveyTypeFromJSONTyped(json, false);
}

export function SurveyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyType {
    return json as SurveyType;
}

export function SurveyTypeToJSON(value?: SurveyType | null): any {
    return value as any;
}

